


// import React, { useState, useEffect } from 'react';
// import { collection, getDocs, query, orderBy } from 'firebase/firestore';
// import { db } from '../../firebase/firebaseConfig'; // Adjust the import path as necessary
// import './LiveHackathons.css';

// export default function LiveHackathons() {
//   const [hackathons, setHackathons] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Fetch hackathons from Firestore
//   useEffect(() => {
//     const fetchHackathons = async () => {
//       try {
//         setLoading(true);
//         const hackathonsQuery = query(
//           collection(db, 'hackathons'),
//           orderBy('date', 'asc')
//         );
//         const querySnapshot = await getDocs(hackathonsQuery);
        
//         const hackathonsList = querySnapshot.docs.map(doc => ({
//           id: doc.id,
//           ...doc.data()
//         }));
        
//         // If no data in Firestore yet, use local data
//         if (hackathonsList.length === 0) {
//           setHackathons(localHackathonsData);
//         } else {
//           setHackathons(hackathonsList);
//         }
//       } catch (error) {
//         console.error("Error fetching hackathons:", error);
//         // Fallback to local data if Firestore fetch fails
//         setHackathons(localHackathonsData);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchHackathons();
//   }, []);

//   // Local hackathons data as fallback
//   const localHackathonsData = [
//     {
//       id: 1,
//       title: 'IoT for Smart Cities',
//       organizer: 'TechCrunch',
//       date: 'July 15-17, 2025',
//       location: 'Bengaluru, India',
//       description: 'Build innovative IoT solutions to address urban challenges and create smarter, more sustainable cities.',
//       imageUrl: 'https://media.licdn.com/dms/image/v2/D5612AQGvojwcSI-PdQ/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1682340969744?e=2147483647&v=beta&t=BM0EkXWx3GNr6zjQmn3GMRhAEGn0Xli1EhnrvQ6t_qo',
//       link: 'https://techcrunch.com/events/',
//       registrationOpen: true
//     },
//     {
//       id: 2,
//       title: 'National Robotics Challenge',
//       organizer: 'Ministry of Electronics & IT',
//       date: 'August 5-7, 2025',
//       location: 'New Delhi, India',
//       description: 'Design and build next-generation robots to solve real-world problems in healthcare, agriculture, and manufacturing.',
//       imageUrl: 'https://static.sliit.lk/wp-content/uploads/2023/10/22104713/ROBOFEST-2023-1.jpg',
//       link: 'https://meity.gov.in/',
//       registrationOpen: true
//     },
//     {
//       id: 3,
//       title: 'Sustainable Energy Hackathon',
//       organizer: 'CleanTech Alliance',
//       date: 'July 28-30, 2025',
//       location: 'Virtual Event',
//       description: 'Develop innovative solutions for renewable energy generation, storage, and distribution systems.',
//       imageUrl: 'https://www.biu.ac.il/sites/default/files/styles/article_image_mobile/public/2022-07/%D7%94%D7%90%D7%A7%D7%AA%D7%95%D7%9F%20%D7%97%D7%A9%D7%9E%D7%9C.jpg?itok=gPHarkr4',
//       link: 'https://cleantechalliance.org/',
//       registrationOpen: true
//     },
//     {
//       id: 4,
//       title: 'AI & Machine Learning Challenge',
//       organizer: 'Google Developer Groups',
//       date: 'August 12-14, 2025',
//       location: 'Hyderabad, India',
//       description: 'Leverage artificial intelligence and machine learning to create innovative solutions for real-world challenges.',
//       imageUrl: 'https://t3.ftcdn.net/jpg/02/52/35/26/360_F_252352610_NcFt5bkPTIIFWaryUO8juR5xTK0S6UsJ.jpg',
//       link: 'https://developers.google.com/community/gdg',
//       registrationOpen: true
//     },
//     {
//       id: 5,
//       title: 'Hardware Startup Weekend',
//       organizer: 'Makers Asylum',
//       date: 'July 22-24, 2025',
//       location: 'Mumbai, India',
//       description: 'A 54-hour weekend event where hardware enthusiasts come together to build innovative hardware products.',
//       imageUrl: 'https://image.typedream.com/cdn-cgi/image/width=384,format=auto,fit=scale-down,quality=100/https://api.typedream.com/v0/document/public/003c6b3e-3f45-4386-88d8-7d7494f9e7b2/2ThgfU6aGbqnFthPcKVwOGNgk7s_isometric-teamwork-and-business-company-framework.png',
//       link: 'https://www.makersasylum.com/',
//       registrationOpen: false,
//     }
//   ];

//   // Handle external link navigation
//   const navigateToExternalLink1 = (url) => {
//     window.open(url, '_blank', 'noopener,noreferrer');
//   };

//   if (loading) {
//     return (
//       <div className="hackathons-container1">
//         <h2 className="section-title1">Live Hackathons</h2>
//         <div className="loading-indicator1">Loading hackathons...</div>
//       </div>
//     );
//   }

//   return (
//     <><div>
//           <h2 className="testimonials-heading1">Live Hackathons</h2>
//       </div><div className="hackathons-container1">
//               <h2 className="section-title1">Live Hackathons</h2>

//               <div className="hackathon-grid1">
//                   {hackathons.map((hackathon) => (
//                       <div key={hackathon.id} className="hackathon-card1">
//                           <div className="hackathon-image-container1">
//                               <img
//                                   src={hackathon.imageUrl}
//                                   alt={hackathon.title}
//                                   className="hackathon-img1" />
//                               {hackathon.registrationOpen && (
//                                   <div className="registration-badge1">Registration Open</div>
//                               )}
//                           </div>
//                           <div className="hackathon-content1">
//                               <h3 className="hackathon-title1">{hackathon.title}</h3>
//                               <div className="hackathon-meta1">
//                                   <div className="hackathon-organizer1">
//                                       <span className="meta-icon1">🏢</span> {hackathon.organizer}
//                                   </div>
//                                   <div className="hackathon-date1">
//                                       <span className="meta-icon1">📅</span> {hackathon.date}
//                                   </div>
//                                   <div className="hackathon-location1">
//                                       <span className="meta-icon1">📍</span> {hackathon.location}
//                                   </div>
//                               </div>
//                               <p className="hackathon-description1">{hackathon.description}</p>
//                               <button
//                                   className="hackathon-cta1"
//                                   onClick={() => navigateToExternalLink1(hackathon.link)}
//                               >
//                                   Register Now
//                               </button>
//                           </div>
//                       </div>
//                   ))}
//               </div>
//           </div></>
//   );
// }




import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy, where } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig'; // Adjust the import path as necessary
import './LiveHackathons.css';

export default function LiveHackathons() {
  const [hackathons, setHackathons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch hackathons from Firestore
  useEffect(() => {
    const fetchHackathons = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Query to get hackathons ordered by date
        const hackathonsQuery = query(
          collection(db, 'hackathons'),
          orderBy('date', 'asc')
        );
        
        const querySnapshot = await getDocs(hackathonsQuery);
        
        if (querySnapshot.empty) {
          // If no data in Firestore, use local fallback data
          setHackathons(localHackathonsData);
        } else {
          // Map Firestore documents to our data structure
          const hackathonsList = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));
          
          setHackathons(hackathonsList);
        }
      } catch (error) {
        console.error("Error fetching hackathons:", error);
        setError("Failed to load hackathons. Please try again later.");
        // Fallback to local data if Firestore fetch fails
        setHackathons(localHackathonsData);
      } finally {
        setLoading(false);
      }
    };

    fetchHackathons();
  }, []);

  // Local hackathons data as fallback
  const localHackathonsData = [
    {
      id: 1,
      title: 'IoT for Smart Cities',
      organizer: 'TechCrunch',
      date: 'July 15-17, 2025',
      location: 'Bengaluru, India',
      description: 'Build innovative IoT solutions to address urban challenges and create smarter, more sustainable cities.',
      imageUrl: 'https://media.licdn.com/dms/image/v2/D5612AQGvojwcSI-PdQ/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1682340969744?e=2147483647&v=beta&t=BM0EkXWx3GNr6zjQmn3GMRhAEGn0Xli1EhnrvQ6t_qo',
      link: 'https://techcrunch.com/events/',
      registrationOpen: true
    },
    {
      id: 2,
      title: 'National Robotics Challenge',
      organizer: 'Ministry of Electronics & IT',
      date: 'August 5-7, 2025',
      location: 'New Delhi, India',
      description: 'Design and build next-generation robots to solve real-world problems in healthcare, agriculture, and manufacturing.',
      imageUrl: 'https://static.sliit.lk/wp-content/uploads/2023/10/22104713/ROBOFEST-2023-1.jpg',
      link: 'https://meity.gov.in/',
      registrationOpen: true
    },
    {
      id: 3,
      title: 'Sustainable Energy Hackathon',
      organizer: 'CleanTech Alliance',
      date: 'July 28-30, 2025',
      location: 'Virtual Event',
      description: 'Develop innovative solutions for renewable energy generation, storage, and distribution systems.',
      imageUrl: 'https://www.biu.ac.il/sites/default/files/styles/article_image_mobile/public/2022-07/%D7%94%D7%90%D7%A7%D7%AA%D7%95%D7%9F%20%D7%97%D7%A9%D7%9E%D7%9C.jpg?itok=gPHarkr4',
      link: 'https://cleantechalliance.org/',
      registrationOpen: true
    },
    {
      id: 4,
      title: 'AI & Machine Learning Challenge',
      organizer: 'Google Developer Groups',
      date: 'August 12-14, 2025',
      location: 'Hyderabad, India',
      description: 'Leverage artificial intelligence and machine learning to create innovative solutions for real-world challenges.',
      imageUrl: 'https://t3.ftcdn.net/jpg/02/52/35/26/360_F_252352610_NcFt5bkPTIIFWaryUO8juR5xTK0S6UsJ.jpg',
      link: 'https://developers.google.com/community/gdg',
      registrationOpen: true
    },
    {
      id: 5,
      title: 'Hardware Startup Weekend',
      organizer: 'Makers Asylum',
      date: 'July 22-24, 2025',
      location: 'Mumbai, India',
      description: 'A 54-hour weekend event where hardware enthusiasts come together to build innovative hardware products.',
      imageUrl: 'https://image.typedream.com/cdn-cgi/image/width=384,format=auto,fit=scale-down,quality=100/https://api.typedream.com/v0/document/public/003c6b3e-3f45-4386-88d8-7d7494f9e7b2/2ThgfU6aGbqnFthPcKVwOGNgk7s_isometric-teamwork-and-business-company-framework.png',
      link: 'https://www.makersasylum.com/',
      registrationOpen: false,
    }
  ];

  // Handle external link navigation
  const navigateToRegistration = (url, isOpen) => {
    if (!isOpen) {
      alert("Registration is currently closed for this hackathon.");
      return;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  // Loading state
  if (loading) {
    return (
      <div className="hackathons-container1">
        <h2 className="section-title1">Live Hackathons</h2>
        <div className="loading-indicator1">
          <div className="loading-spinner1"></div>
          <p>Loading hackathons...</p>
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="hackathons-container1">
        <h2 className="section-title1">Live Hackathons</h2>
        <div className="error-message1">
          <p>{error}</p>
          <button 
            onClick={() => window.location.reload()}
            className="reload-button1"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="hackathons-container1">
      <h2 className="section-title1">Live Hackathons</h2>

      <div className="hackathon-grid1">
        {hackathons.map((hackathon) => (
          <div key={hackathon.id} className="hackathon-card1">
            <div className="hackathon-image-container1">
              <img
                src={hackathon.imageUrl}
                alt={hackathon.title}
                className="hackathon-img1" 
              />
              {hackathon.registrationOpen ? (
                <div className="registration-badge1">Registration Open</div>
              ) : (
                <div className="registration-badge1 closed">Registration Closed</div>
              )}
            </div>
            <div className="hackathon-content1">
              <h3 className="hackathon-title1">{hackathon.title}</h3>
              <div className="hackathon-meta1">
                <div className="hackathon-organizer1">
                  <span className="meta-icon1">🏢</span> {hackathon.organizer}
                </div>
                <div className="hackathon-date1">
                  <span className="meta-icon1">📅</span> {hackathon.date}
                </div>
                <div className="hackathon-location1">
                  <span className="meta-icon1">📍</span> {hackathon.location}
                </div>
              </div>
              <p className="hackathon-description1">{hackathon.description}</p>
              <button
                className={`hackathon-cta1 ${!hackathon.registrationOpen ? 'disabled' : ''}`}
                onClick={() => navigateToRegistration(hackathon.link, hackathon.registrationOpen)}
              >
                {hackathon.registrationOpen ? 'Register Now' : 'Registration Closed'}
              </button>
            </div>
          </div>
        ))}
      </div>
      
      {hackathons.length === 0 && (
        <div className="no-hackathons1">
          <p>No upcoming hackathons found. Please check back later!</p>
        </div>
      )}
    </div>
  );
}